






































































































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class';
import BaseFilter from '@/components/Filter/BaseFilter';
import {notifyError, notifyWarning} from '@/utils/notify-helper';
import {PushSubscribersFilter} from "@/store/push/subscribers/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {FastDateDetailWings, DatePickerWings, SelectWings, InputWings} from "wings-ui-components";
import {AccountFilter} from "@/store/settings/accounts/types";

@Component({
  components: {FastDateDetailWings, SelectWings, DatePickerWings, InputWings},
  filters: {dateFilter}
})
export default class PushSubscriberFilter extends BaseFilter<PushSubscribersFilter> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;
  @Action("getPushSubscribers") actionGetPushSubscribers: any;
  @Action("getPushApplications") actionGetPushApplications: any;
  @Action("getApplicationAttributes") actionGetApplicationAttributes: any;

  @Getter("pushApplications") pushApplicationsList: any;
  @Getter("applicationAttributes") pushApplicationAttributes: any;

  private selectedAttributes: string[] = [];

  defaultFilter(): PushSubscribersFilter {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      application: null,
      attr_subscriber: {},
      page_number: 1
    };
  }

  created() {
    this.scroll();
    this.actionGetPushApplications();
  }

  async onFilteredAction(nextPage = false){
    const payload = {...this.filter, attr_subscriber: JSON.stringify(this.filter.attr_subscriber)};
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Subscribers",
        addititional_info: getTranslatedParams(this.filter)
      };
      const res = await this.actionGetPushSubscribers(payload);
      await this.actionLog(this.logObject);
      this.is_last = res.length == 0;
      if (res.status == 204) {
        notifyWarning();
      }
    } catch (err) {
      this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(err);
    }
  }

  getApplicationId(name: string): string {
    const application = this.pushApplicationsList.find((item: any) => item.name === name);
    return application ? application.id : '';
  }

  unsetAttributeByName(name: string) {
    delete this.filter.attr_subscriber?.[name];
    this.selectedAttributes = this.selectedAttributes.filter((item: string) => item !== name);
  }

  @Watch('filter.application', { immediate: false })
  onApplicationChanged(newVal: string) {
    if (newVal) {
      this.actionGetApplicationAttributes({ application_id: this.getApplicationId(newVal), filter: { owner: 'client' } });
    } else {
      this.selectedAttributes = [];
      this.filter.attr_subscriber = {};
    }
  }

  @Watch('selectedAttributes', { immediate: true, deep: true })
  onSelectedAttributesChanged() {
    const updated: Record<string, string> = { ...this.filter.attr_subscriber };

    this.selectedAttributes.forEach((name: string) => {
      if (!updated[name]) updated[name] = '';
    });

    Object.keys(updated).forEach(key => {
      if (!this.selectedAttributes.includes(key)) delete updated[key];
    });

    this.filter.attr_subscriber = updated;
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: AccountFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
